import React from 'react'

import DoctorsTable from 'presentation/hospital/components/DoctorsTable'
import ContainerNew from 'presentation/hospital/components/ContainerNew'

export default function DoctorsLayout() {
  return (
    <ContainerNew>
      <DoctorsTable />
    </ContainerNew>
  )
}
